import moment from 'moment'
import { mapState } from 'vuex'
import { getServiceDetail, formatTimeCalendar, legacy_getOrderFeeDetail } from '../plugins/util'
import { updateOrderInfo, getOrderDataToReuse } from '../utils/order'

const { find, merge } = require('@/plugins/lodash')

const mixin = {
  computed: {
    ...mapState({
      userProfile: (state) => state.user.profile,
      services: (state) => state.serviceTypes.service_types,
      locale: (state) => state.locale
    }),
    currentUserId() {
      return this.userProfile && this.userProfile._id
    }
  },
  methods: {
    $_record_formatTimeCalendar(time) {
      return formatTimeCalendar(time, this.locale)
    },

    $_record_formatTime(time) {
      return moment.unix(time).format('DD-MM-Y, H:mm')
    },

    $_record_formatTimeForExport(time) {
      // console.log('_record_formatTimeForExport', moment.unix(time))
      return moment.unix(time).format('DD-MM-Y, H:mm')
    },

    $_record_updateOrderRequest(service, order) {
      if (service) {
        const serviceRequests = service.requests
        if (order.requests) {
          order.requests.forEach((request) => {
            const orgReq = find(serviceRequests, { _id: request._id })
            const copyOrgReq = Object.assign({}, orgReq, request)
            merge(request, copyOrgReq)
            request.name_label = request['name' + this.$store.getters.localeSuffix] || request.name
          })
        }
      }
    },

    $_record_updateFinalTotalFee(service, order) {
      this.$_record_updateOrderRequest(service, order)
      // Map fee detail from api data
      // const extraFeeDetail = getOrderFeeDetail(order)
      // Map fee detail from rest_api data
      const extraFeeDetail = legacy_getOrderFeeDetail(order)

      Object.assign(order, extraFeeDetail)
    },

    $_record_getServiceDetail(serviceId) {
      const api = `${process.env.VUE_APP_API_URL}${this.$constants.API.order.service_detail}?format=json&service_id=${serviceId}`
      return new Promise((resolve, reject) => {
        this.axios
          .get(api)
          .then((response) => {
            resolve(response)
          })
          .catch((error) => {
            // todo: handle error
            reject(error)
          })
      })
    },

    $_record_updateOrderGeneral(order, service) {
      updateOrderInfo(order, {
        service,
        locale: this.locale,
        currentUserId: this.currentUserId,
        localeSuffix: this.$store.getters.localeSuffix
      })
    },
    $_record_buildNewStateOrderForm(order, service) {
      return getOrderDataToReuse(order, service)
    },
    $_record_getOrderServiceDetail(serviceId) {
      return new Promise((resolve) => {
        // console.log('$_record_getOrderServiceDetail', this.services)
        const service = getServiceDetail(this.services, serviceId)
        if (service) {
          resolve(service)
        } else {
          this.$_record_getServiceDetail(serviceId)
            .then((response) => {
              resolve(response.data)
            })
            .catch((er) => {
              console.log('cannot load service detail: ', serviceId, er)
              resolve(null)
            })
        }
      })
    },
    async $_record_getShareLink(params) {
      const api = `${process.env.VUE_APP_API_URL}${this.$constants.API.order.share_link}`
      const paramStr = Object.keys(params)
        .map((key) => key + '=' + params[key])
        .join('&')

      return await this.$mainWorker.callAPI({ url: `${api}?${paramStr}` })
    }
  }
}

export default mixin
